<template>
  <b-card class="w-100 container_couriers_catalog">
    <div>
      <span class="courier-catalog-title-msg"><img src="/icon/clipboard-paste.svg" width="20" height="20" />Catálogo de couriers </span>
      <span class="courier-catalog-msg"
        >(Cada <span class="courier-catalog-msg-weight">courier</span> está representado por su logo y las categorías de servicio que ofrece. Para más detalles,
        selecciona <span class="courier-catalog-msg-weight">'Ver más'</span> y consulta las condiciones específicas de cada servicio).</span
      >
    </div>
    <div class="countries_buttons_group mt-2" v-if="isAdmin()">
      <div class="countries_buttons_container">
        <b-button
          v-for="(country, index) in optionsCountries"
          :key="index"
          class="countries_buttons"
          :class="{ 'selected': selectedCountry === index }"
          @click="changeCountry(index)"
        >
          <img class="fieldSelect--img" :src="require(`@/assets/images/flags/${country.flag}`)" :alt="`Bandera de ${country.name}`" />
          {{ country.name }}
        </b-button>
      </div>
    </div>
    <div v-if="loading.firstCharge">
      <div class="m-3"><b-skeleton class="m-auto" type="input" width="80%"></b-skeleton></div>
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <b-skeleton class="mt-1" type="input" />
          <b-skeleton class="mt-1" type="input" />
        </div>
        <div class="col-sm-12 col-md-12 col-lg-9">
          <b-row>
            <b-col class="col-sm-12 col-md-4 col-lg-4 skeleton_container_card mt-1" v-for="index in 3" :key="index">
              <b-skeleton-img class="m-1 p-1 skeleton_card_img" width="220px" height="280px" />
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <div v-if="!loading.firstCharge">
      <form-render :key="keyFormSearch" :fields="fieldsSearch" :form="formSearch" class="ml-1 custom_search_catalog" ref="formSearch">
        <template #buttons>
          <b-button variant="outline-light" v-b-tooltip.hover title="Limpiar filtros" class="mt-2" @click="cleanFilter">
            <feather-icon icon="RefreshCwIcon" />
          </b-button>
        </template>
      </form-render>
      <div class="container_couriers_catalog mt-2 w-100">
        <div class="row">
          <div class="col-lg-3 col-md-12">
            <div class="text-primary">
              <feather-icon icon="FilterIcon" size="20" /> Filtros
              <ul class="mt-1 pl-1 link" variant="link">
                <li class="ml-0">Puedes usarlos por separado o combinarlos según tus necesidades.</li>
              </ul>
            </div>
            <div class="divider border-bottom"></div>
            <div v-if="valueTags.length">
              <span class="ml-2 font-weight-bold d-block">Filtros activos:</span>
              <b-badge class="badge__cnt d-block fit-content justify-content-between" v-for="(data, index) in valueTags" :key="`${index}_valueTags`">
                <span>{{ data.text }}</span>
                <b-button variant="outline" class="border-0 p-0 pl-1" size="sm" @click="removeTag(data, index)">
                  <feather-icon icon="XIcon" class="warning color_icon" />
                </b-button>
              </b-badge>
              <div class="divider border-bottom"></div>
            </div>
            <span class="font-weight-bold d-flex justify-content-between cursor-pointer" @click="changeCategories">
              <span><feather-icon icon="SettingsIcon" /> Categorías de servicio ({{ categoriesOptions.length }})</span>
              <span><feather-icon :icon="iconDeliveryAttempts ? 'ChevronUpIcon' : 'ChevronDownIcon'" /></span>
            </span>
            <div v-show="isShowCategories">
              <b-form-radio-group
                value-field="type"
                v-model="form.categoriesSelected"
                :options="categoriesOptions"
                class="m-2 radio_group_categories"
                stacked
                @change="sendForm"
              ></b-form-radio-group>
            </div>
            <div class="divider border-bottom"></div>
            <span class="font-weight-bold d-flex justify-content-between cursor-pointer" @click="changeConditions">
              <span><img src="/icon/journal-check.svg" alt="image" width="14" /> Condiciones (5)</span>
              <span><feather-icon :icon="iconConditions ? 'ChevronUpIcon' : 'ChevronDownIcon'" /></span>
            </span>
            <div v-if="isShowConditions">
              <b-form-checkbox v-model="form.deliveryAttempts" name="deliveryAttempts" @change="changeDeliveryAttempts" class="m-1"
                >Intentos de entrega</b-form-checkbox
              >
              <b-form-radio-group
                v-if="form.deliveryAttempts"
                v-model="form.radioDeliveryAttempts"
                :options="deliveryAttemptsOptions"
                class="m-2 radio_delivery_attempts"
                stacked
                @change="sendForm"
              ></b-form-radio-group>
              <b-form-checkbox v-model="form.checkboxQuantityPackages" name="checkboxQuantityPackages" class="m-1" @change="changeCheckboxQuantityPackages"
                >Bultos para recolección diaria</b-form-checkbox
              >
              <div class="quantity_packages">
                <b-form-input
                  v-if="form.checkboxQuantityPackages"
                  v-model="form.quantityPackages"
                  type="number"
                  min="0"
                  max="200"
                  placeholder="Ingresa el números de bultos"
                  class="col-11"
                  @input.native="changeQuantityPackages"
                  useSkeleton="true"
                ></b-form-input>
              </div>
              <b-form-checkbox v-model="form.checkboxMultipack" name="checkboxMultipack" @change="sendForm" class="m-1">Multibulto</b-form-checkbox>
              <b-form-checkbox v-model="form.checkboxReverseLogistics" name="checkboxReverseLogistics" @change="sendForm" class="m-1"
                >Logística inversa</b-form-checkbox
              >
              <!-- Se comenta mientras solucionamos el tema del seguro -->
              <b-form-checkbox v-if="country.code === 'CL'" v-model="form.checkboxInsuranceIncluded" name="checkboxInsuranceIncluded" class="m-1" @change="changeCheckboxInsuranceIncluded">
                Seguro incluído
              </b-form-checkbox>
              <div v-if="form.checkboxInsuranceIncluded" class="d-flex justify-content-between">
              </div>
              <div class="quantity_packages" v-if="form.checkboxInsuranceIncluded">
                <div class="text_insurance_included text-secondary mb-1">
                  <p>Usa la barra o casilla para definir el valor máximo de tus productos.</p>
                  <p>Se entregarán opciones con seguros que indemnicen hasta el valor indicado</p>
                  <p>{{ (currency_exchange) && `Los valores han sido calculados segun el tipo de cambio 1 ${currency_exchange.code} = ${currency_exchange.value}` }}</p>
                </div>
                <div class="text_insurance_included mt-4">
                  <div ref="slider" class="slider" id="slider-round"></div>
                  <div class="d-flex justify-content-between mt-1">
                    <p>{{ `${$options.filters.currencySymbol(country.code)} ${$options.filters.currency(0)}` }}</p>
                    <p>{{ `${$options.filters.currencySymbol(country.code)} ${$options.filters.currency(insuranceMaxValue)}` }}</p>
                  </div>
                </div>
                <form-render :key="keyFormInsurance" :fields="fieldsInsurance" :form="formInsurance" class="d-flex form-insurance" ref="formInsurance"></form-render>
              </div>
              <b-form-checkbox v-if="isCoPeMx" v-model="form.with_cod" name="with_cod" class="m-1" @change="sendForm">Recaudo contra entrega</b-form-checkbox>
            </div>
            <div class="divider border-bottom"></div>
            <div class="text-primary">
              <ul class="mt-1 pl-1 link" variant="link">
                <li class="ml-0">Puedes comparar filtrando de 2 a 6 couriers y una categoría de servicio.</li>
              </ul>
            </div>
            <div v-b-tooltip.hover title="Filtre entre 2 a 6 couriers y una categoría de servicio para comparar">
              <a
                @click="comparatorCouriers"
                class="btn btn-warning mt-2 mb-4 comparator-couriers"
                v-b-tooltip.hover
                :class="{ disabled: !form.categoriesSelected || displayedItems.length < 2 || displayedItems.length > 6 }"
              >
                <img
                  :src="require(`@/assets/images/icons/couriers-catalog-icons/buttonComparatorIcon.svg`)"
                  alt="Comparator Icon"
                />
                <span class="ml-1 comparator-button">Comparar</span>
              </a>
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-9">
            <div class="couriers-catalog" v-if="!loading.card">
              <b-row>
                <b-col class="col-sm-12 col-md-4 col-lg-4 col_courier_card" v-for="(courier, index) in displayedItems" :key="index">
                  <b-card class="courier_card" :title="courier.name" tag="article">
                    <div class="courier_img_card text-center">
                      <img :src="(courier.logoUrl)" class="logo_img" @click="goToDetail({country_id: country.id, courier_id: courier.carrier_id, courier_name: courier.carrier_name, services: courier.services.map(service => service.service_id).join(',')})"/>
                    </div>
                    <div class="courier_div_card p-1">
                      <div class="courier_div_span_card">Servicios disponibles</div>
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex">
                          <div v-for="(icon, index) in courier.codeCategoriesServices" :key="index" class="icon_sevice_types">
                            <img v-if="icon" :src="`/icon/${icon.type}.svg`" width="20" v-b-tooltip.hover :title="icon" />
                          </div>
                        </div>
                        <a @click="goToDetail({country_id: country.id, courier_id: courier.carrier_id, courier_name: courier.carrier_name, services: courier.services.map(service => service.service_id).join(',')})" class="text-primary">
                          <span class="font-weight-bold">Ver más</span>
                        </a>
                      </div>
                    </div>
                  </b-card>
                </b-col>
                <div v-if="!(displayedItems.length)" class="text-center text-secondary custom_div_msg">
                  <img :src="'/icon/search.svg'" width="60" v-b-tooltip.hover title="icon search" />
                  <p class="custom_text">No hemos encontrado resultados para su búsqueda.</p>
                </div>
              </b-row>
              <div class="text-center" v-if="loading.scroll"><b-spinner /></div>
            </div>
            <div v-if="loading.card">
              <b-row>
                <b-col class="col-4 skeleton_container_card" v-for="index in 9" :key="index">
                  <b-skeleton-img class="m-1 p-1 skeleton_card_img" width="200px" height="220px" />
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-card>
</template>
<script>
import { mapGetters } from 'vuex'
import BaseServices from '@/store/services/index'
import noUiSlider from 'nouislider'
import 'nouislider/dist/nouislider.css'


export default {
  name: 'CouriersCatalog',
  components: {},
  data () {
    return {
      baseService: new BaseServices(this),
      optionsCountries: [
        { name: 'Chile', flag: 'cl.png', code: 'CL', id: 1 },
        { name: 'Colombia', flag: 'co.png', code: 'CO', id: 3 },
        { name: 'Perú', flag: 'pe.png', code: 'PE', id: 4 },
        { name: 'México', flag: 'mx.png', code: 'MX', id: 2 }
      ],
      form: {},
      keyFormSearch: 0,
      fieldsSearch: [],
      formSearch: {},
      selectedCountry: 0,
      country: {},
      isShowCategories: false,
      categoriesOptions: [],
      isShowConditions: false,
      deliveryAttemptsOptions: [
        {text: '+ 1', value: 1},
        {text: '+ 2', value: 2},
        {text: '+ 3', value: 3}
      ],
      isCoPeMx: false,
      iconDeliveryAttempts: false,
      iconConditions: false,
      valueTags: [],
      couriers: [],
      loading: {
        firstCharge: true,
        card: false,
        scroll: false
      },
      categoriesOrden: ['express', 'sameday', 'nextday', 'estandar', 'general', 'doc', 'logistica-inversa', 'international'],
      displayedItems: [],
      batchSize: 9, // Cantidad de elementos por "página"
      currentIndex: 0,  // Índice actual para ir cargando los siguientes 9 elementos
      debounceTimeout: null,
      range: [],
      keyFormInsurance: 0,
      fieldsInsurance: [],
      formInsurance: {},
      currency_exchange: null,
      courierCatalog: {},
      insuranceMaxValue: 1000000
    }
  },
  computed: {
    ...mapGetters({
      mySession: 'getSession',
      countries: 'getCountriesInCurrentCoverage',
      setCouriers: 'getCourierCatalog'
    })
  },
  watch: {
    setCouriers() {
      this.courierCatalog = this.setCouriers
      this.displayedItems = []
      this.currentIndex = 0
      this.setCourierCatalog(this.courierCatalog)
    },
    countries() {
      if (this.isAdmin()) {
        this.country = this.countries.rows.find(country => country.code === this.optionsCountries[this.selectedCountry].code)
      } else {
        this.country = this.$session.get('cas_user').country
      }
      if (this.$route.query.country) {
        const index = this.optionsCountries.findIndex(country => country.id === parseInt(this.$route.query.country))
        if (index !== -1) this.changeCountry(index)
      } else {
        this.getCouriersServiceTypesCourierCatalog()
      }
    },
    mySession() {
      if (this.mySession?.id) {
        this.setInitialData()
      }
    }
  },
  mounted() {
    if (this.mySession?.id) {
      this.setInitialData()
    }
  },
  methods: {
    async setInitialData() {
      this.fieldsSearch = [
        { fieldType: 'FieldSelect', useSkeleton: true, name: 'searchCouriers', containerClass: 'col-10 mt-2', change: this.sendForm, sort: true, multiple: true, max: 6, placeholder: 'Buscar por nombre, hasta un máximo de 6 couriers' }
      ]
      await this.$store.dispatch('fetchService', { name: 'getCountriesInCurrentCoverage' })
      this.fieldsInsurance = [
        {fieldType: 'FieldInput', label: this.$t('Desde'), name: 'sliderMinValue', id: 'sliderMinValue', containerClass: 'col-6', type:'number', change: this.changeInsurancecalues, disabled: true},
        {fieldType: 'FieldInput', label: this.$t('Hasta'), name: 'sliderMaxValue', id: 'sliderMaxValue', containerClass: 'col-6', type:'number', change: this.changeInsurancecalues}
      ]
    },
    setData(response) {
      const { getServiceTypesByCountry, getCourierCatalog } = response
      this.categoriesOptions = getServiceTypesByCountry?.data?.map(el => ({
        ...el,
        text: el.name,
        type: el.type
      })) || []
      const countryFilterMap = {
        MX: ['express', 'sameday', 'nextday', 'general', 'international'],
        CL: ['express', 'sameday', 'nextday', 'general', 'doc', 'logistica-inversa'],
        CO: ['express', 'sameday', 'nextday', 'estandar', 'logistica-inversa'],
        PE: ['express', 'sameday', 'nextday', 'logistica-inversa']
      }
      if (this.country?.code && countryFilterMap[this.country.code]) {
        const allowedTypes = countryFilterMap[this.country.code]
        this.categoriesOptions = this.categoriesOptions.filter(category => allowedTypes.includes(category.type))
      }
      this.categoriesOptions.sort((a, b) => this.categoriesOrden.indexOf(a.type) - this.categoriesOrden.indexOf(b.type))
      this.courierCatalog = getCourierCatalog
      this.fieldsSearch[0].options = getCourierCatalog.data.filter(item => Array.isArray(item.logotypes) && item.logotypes.length > 0 && Array.isArray(item.services) && item.services.length > 0).map(el => ({...el, text: el.carrier_name, id: el.carrier_id}))
      this.fieldsSearch[0].useSkeleton = false
      this.setCourierCatalog(getCourierCatalog)
    },
    setCourierCatalog(value) {
      if (value.meta?.insurance?.currency_exchange?.UF || value?.meta?.insurance?.currency_exchange?.UMAS) {
        const keys = Object.keys(value.meta.insurance.currency_exchange)
        this.currency_exchange = {
          code: keys.find(m => ['uf', 'umas'].includes(m.toLowerCase())),
          value: value.meta.insurance.currency_exchange[keys.find(m => ['uf', 'umas'].includes(m.toLowerCase()))],
          symbol: value.meta?.insurance?.symbol || this.$options.filters.currencySymbol(this.country.code)
        }
      }
      if (value?.meta?.insurance?.max_value) this.insuranceMaxValue =  Math.ceil(value.meta.insurance.max_value / 1000000) * 1000000
      if (!this.formInsurance.sliderMinValue) this.formInsurance.sliderMinValue = 0
      if (!this.formInsurance.sliderMaxValue) this.formInsurance.sliderMaxValue = value?.meta?.insurance?.max_value || 1000000
      const nextItems = this.setCourierCatalogRows(value.data)
      this.displayedItems = [...this.displayedItems, ...nextItems]
      this.currentIndex += this.batchSize
      this.loading.card = false
      this.hasScroll()
      window.addEventListener('scroll', this.scrolling)
    },
    setCourierCatalogRows(val) {
      let courierCatalog = val.map(courier => {
        const logoUrl = courier.logotypes?.map(logotype => {
          return logotype?.url
        })
        const serviceTypeIds = [...new Set(courier.services.map(service => service.service_type_id))]
        serviceTypeIds.filter(service => this.categoriesOptions.find(category => category.id === service))
        let categories = serviceTypeIds.map(service => this.categoriesOptions.find(category => category.id === service))
        categories = categories.sort((a, b) => this.categoriesOrden.indexOf(a.type) - this.categoriesOrden.indexOf(b.type))
        categories = categories.filter(category => category)
        const logo = logoUrl?.length ? logoUrl[0] : null
        if (logo && categories?.length) {
          return {
            ...courier,
            logoUrl: logo,
            codeCategoriesServices: categories
          }
        }
      }) || []
      courierCatalog = courierCatalog.filter(courier => courier)
      return courierCatalog.slice(this.currentIndex, this.currentIndex + this.batchSize)
    },
    getCouriersServiceTypesCourierCatalog() {
      const queryParams = {}
      if (this.country?.code.toLowerCase() === 'cl') {
        queryParams.currency_code = 'CLP'
      }
      this.fieldsSearch[0].useSkeleton = true
      const arrServices = [
        { name: 'getCourierCatalog', params: { country_id: this.country.id }, queryParams },
        { name: 'getServiceTypesByCountry', params: { country_id: this.country.id } }
      ]
      this.loading.firstCharge = true
      this.baseService.callMultipleServices(arrServices, true)
        .then(response => {
          if (response) this.setData(response)
        })
        .catch(() => {
          this.loading.firstCharge = false
        })
        .finally(() => this.loading.firstCharge = false)
    },
    getQueryparams() {
      const queryParams = {}
      const idsCarriers = []
      this.valueTags = []
      // couriers
      if (this.formSearch?.searchCouriers?.length) this.formSearch.searchCouriers.forEach(item => idsCarriers.push(item.carrier_id))
      if (idsCarriers.length) queryParams['carriers[]'] = idsCarriers
      // categories
      if (this.form.categoriesSelected) {
        queryParams['service_types[]'] = [parseInt(this.categoriesOptions.find(category => category.type === this.form.categoriesSelected).id)]
        this.valueTags.push({ text: this.categoriesOptions.find(category => category.type === this.form.categoriesSelected).name, type: 'categories' })
      }
      // Intentos de entrega
      if (this.form.radioDeliveryAttempts) {
        queryParams.delivery_attempts = parseInt(this.form.radioDeliveryAttempts)
        this.valueTags.push({text: `Intentos de entrega ${this.form.radioDeliveryAttempts}`, type: 'radioDeliveryAttempts'})
      }
      // Bultos para recolección diaria
      if (this.form.quantityPackages) {
        queryParams.min_pickup = parseInt(this.form.quantityPackages)
        this.valueTags.push({text: `Bultos para recolección diaria ${this.form.quantityPackages}`, type: 'quantityPackages'})
      }
      // multibulto
      if (this.form.checkboxMultipack) {
        queryParams.multipack = true
        this.valueTags.push({text: 'Multibulto', type: 'checkboxMultipack'})
      }
      // Logística inversa
      if (this.form.checkboxReverseLogistics) {
        queryParams.is_return = !!this.form.checkboxReverseLogistics
        this.valueTags.push({text: 'Logística inversa', type: 'checkboxReverseLogistics'})
      }
      // Seguro incluído
      if (this.form.checkboxInsuranceIncluded && (this.formInsurance.sliderMinValue || this.formInsurance.sliderMaxValue)) {
        queryParams.start_insurance_value = parseInt(this.range[0])
        queryParams.end_insurance_value = parseInt(this.range[1])
        queryParams.currency_code = 'CLP'
        this.valueTags.push({text: `Seguro ${this.$options.filters.currencySymbol(this.country.code)}${this.$options.filters.currency(this.range[0])} - ${this.$options.filters.currencySymbol(this.country.code)}${this.$options.filters.currency(this.range[1])}`, type: 'insuranceIncluded'})

      }
      // Recaudo contra entrega
      if (this.form.with_cod) {
        queryParams.with_cod = !!this.form.with_cod
        this.valueTags.push({text: 'Recaudo contra entrega', type: 'with_cod'})
      }
      // currency_code
      if (this.country?.code.toLowerCase() === 'cl') {
        queryParams.currency_code = 'CLP'
      }
      return queryParams
    },
    changeCountry(index) {
      this.country = this.optionsCountries[index]
      this.displayedItems = []
      this.currentIndex = 0
      this.form = {}
      this.valueTags = []
      delete this.formSearch.searchCouriers
      this.selectedCountry = index // Actualiza el país seleccionado
      this.getCouriersServiceTypesCourierCatalog()
      if (this.optionsCountries[index].code === 'CO' || this.optionsCountries[index].code === 'PE' || this.optionsCountries[index].code === 'MX') {
        this.isCoPeMx = true
      } else {
        this.isCoPeMx = false
      }
    },
    changeCategories() {
      this.isShowCategories = !this.isShowCategories
      this.iconDeliveryAttempts = !this.iconDeliveryAttempts
    },
    changeCheckboxQuantityPackages(value) {
      delete this.form.quantityPackages
      if (!value) this.sendForm()
    },
    changeConditions() {
      this.isShowConditions = !this.isShowConditions
      this.iconConditions = !this.iconConditions
    },
    changeDeliveryAttempts(value) {
      delete this.form.radioDeliveryAttempts
      if (value) this.form.radioDeliveryAttempts = 1
      this.sendForm()
    },
    changeCheckboxInsuranceIncluded(value) {
      if (!value) {
        delete this.formInsurance.sliderMinValue
        delete this.formInsurance.sliderMaxValue
      } else {
        const format = {
          to: (value) => {
            // Formatear el número con separación de miles
            return new Intl.NumberFormat('es-ES').format(parseInt(value))
          },
          from: (value) => {
            // Eliminar los puntos de separación de miles y convertir a número
            return parseInt(value.toString().replace(/\./g, ''))
          }
        }
        this.range = [this.formInsurance.sliderMinValue, this.formInsurance.sliderMaxValue]
        this.$nextTick(() => {
          const slider = this.$refs.slider
          // Crear el slider
          noUiSlider.create(slider, {
            start: this.range,
            tooltips: true,
            format,
            connect: true,
            range: {
              min: 0,
              max: Math.floor(this.insuranceMaxValue) || parseInt(1000000)
            }
          })
          let debounceTimeout = null
          let isUpdating = false
          // Actualizar los valores del rango cuando el slider cambia
          slider.noUiSlider.on('update', (values, handle) => {
            if (isUpdating) return // Evitar la actualización si la bandera está activa
            this.range = values.map((v) => {
              return Math.round(parseInt(v.toString().replace(/\./g, '')))
            })
            if (handle === 0) {
              isUpdating = true // Activar la bandera
              slider.noUiSlider.set([0, values[1]]) // Actualizar el slider
              isUpdating = false // Desactivar la bandera
            }
            clearTimeout(debounceTimeout)
            // Configurar un nuevo temporizador
            debounceTimeout = setTimeout(() => {
              if (this.range[0] !== this.formInsurance.sliderMinValue || this.range[1] !== this.formInsurance.sliderMaxValue) {
                this.formInsurance.sliderMinValue = this.range[0]
                this.formInsurance.sliderMaxValue = this.range[1]
                this.keyFormInsurance++
              }
              this.sendForm()
            }, 1000) // Retraso de 500 ms
          })
        })
      }
      this.sendForm()
    },
    changeInsurancecalues(name, val) {
      this.range = [this.formInsurance.sliderMinValue, this.formInsurance.sliderMaxValue]
      this.$refs.slider.noUiSlider.set(this.range)
    },
    changeQuantityPackages(val) {
      delete this.form.quantityPackages
      const newVal = val.target.value.toString().replace(/[^0-9]/g, '').slice(0, 4) // Limita a 4 caracteres
      val.target.value = newVal
      this.form.quantityPackages = newVal
      clearTimeout(this.debounceTimeout)
      if (val.target.value.length <= 4) this.debounceTimeout = setTimeout(() => {
        this.sendForm()
      }, 600)
    },
    cleanFilter() {
      this.formSearch.searchCouriers = []
      this.valueTags = []
      this.form = {}
      this.sendForm()
    },
    removeTag(data, index) {
      this.valueTags.splice(index, 1)
      if (data.type === 'radioDeliveryAttempts') {
        delete this.form.radioDeliveryAttempts
        delete this.form.deliveryAttempts
      } else if (data.type === 'quantityPackages') {
        delete this.form.quantityPackages
        delete this.form.checkboxQuantityPackages
      } else if (data.type === 'checkboxMultipack') {
        delete this.form.checkboxMultipack
      } else if (data.type === 'checkboxReverseLogistics') {
        delete this.form.checkboxReverseLogistics
      } else if (data.type === 'insuranceIncluded') {
        delete this.form.checkboxInsuranceIncluded
        delete this.formInsurance.sliderMinValue
        delete this.formInsurance.sliderMaxValue
      } else if (data.type === 'Recaudo contra entrega') {
        delete this.form.with_cod
      } else if (data.type === 'categories') {
        delete this.form.categoriesSelected
      }
      this.sendForm()
    },
    sendForm() {
      this.loading.card = true
      this.$store.dispatch('fetchService', { name: 'getCourierCatalog', params: { country_id: this.country.id }, queryParams: this.getQueryparams() })
    },
    setError(error) {
      this.loading.card = false
      this.$newError('Error', `code: ${error}`)
    },
    capitalizeFirstLetter(str) {
      if (!str) return ''
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
    },
    goToDetail(params) {
      this.$router.push({ name: 'details-couriers-catalog', params })
    },
    comparatorCouriers() {
      const country_id = this.country?.id
      const courier_ids = [this.displayedItems?.map(el => el.carrier_id)].join('')
      const service_id = this.categoriesOptions?.find(category => category?.type === this.form.categoriesSelected)?.id
      const service_name = this.capitalizeFirstLetter(this.categoriesOptions?.find(category => category?.type === this.form.categoriesSelected)?.name)
      const service_type = this.categoriesOptions?.find(category => category?.type === this.form.categoriesSelected)?.type
      const filters = this.getQueryparams()
      const params = {country_id, courier_ids, service_name, service_id, service_type}
      // Agregar dinámicamente cada clave-valor al queryParams
      for (const key in filters) {
        if (Object.hasOwnProperty.call(filters, key)) {
          params[key] = filters[key]
        }
      }
      this.$router.push({ name: 'catalog-comparator', query: params })
    },
    isAdmin() {
      return this.mySession?.role === 'admin'
    },
    scrolling({target}) {
      const {scrollingElement} = target
      if ((scrollingElement.scrollTop + scrollingElement.clientHeight + 500) >= scrollingElement.scrollHeight) {
        this.next()
      }
    },
    hasScroll() {
      const hasScroll = document.documentElement.scrollHeight > document.documentElement.clientHeight
      if (!hasScroll) {
        this.next()
      }
    },
    loadItems() {
      const nextItems = this.setCourierCatalogRows(this.courierCatalog.data)
      this.displayedItems = [...this.displayedItems, ...nextItems]
      this.currentIndex += this.batchSize
      this.loading.scroll = false
    },
    next() {
      if (this.currentIndex >= this.courierCatalog.data?.length) return this.loading.scroll = false // Si ya no hay más, no carga
      this.loading.scroll = true
      clearTimeout(this.debounceTimeout)
      this.debounceTimeout = setTimeout(() => {
        this.loadItems()
        this.hasScroll()
      }, 200)
    }
  }
}
</script>
<style lang="scss">
  .courier-catalog-msg {
    font-size: 12px;
  }
  .courier-catalog-title-msg {
    color: #f18805;
    font-weight: 500;
  }
  .courier-catalog-msg-weight {
    font-weight: 700;
  }
  .countries_buttons_group {
    margin-bottom: 1rem;
    display: flex;
    flex: 1;
    justify-content: center;
    border-radius: 5px;
    @media screen and (max-width: 768px) {
      border: none !important;
      justify-items: center;
    }
  }
  .countries_buttons_container {
    display: flex;
    flex: 1;
    width: 100% !important;
    max-width: fit-content;
    border-radius: 5px;
    box-shadow:
      /* Sombra leve arriba */
      0px 0px 0px rgba(0, 0, 0, 0.1),
      /* Sombra leve izquierda */
      0px 0px 0px rgba(0, 0, 0, 0.1),
      /* Sombra leve derecha */
      0px 0px 0px rgba(0, 0, 0, 0.1),
      /* Sombra más notable abajo */
      0px 4px 12px rgba(0, 0, 0, 0.2);
      :nth-child(-n+3) {
        border-right: 1px solid rgba(0, 0, 0, 0.1) !important;
      }
      :hover {
        border: none !important;
      }
    @media screen and (max-width: 768px) {
      display: grid;
      grid-template-columns: 200px;
      padding: 1rem;
      border: none !important;
      box-shadow:
        /* Sombra leve arriba */
        0px 0px 0px rgba(0, 0, 0, 0.1),
        /* Sombra leve izquierda */
        0px 0px 0px rgba(0, 0, 0, 0.1),
        /* Sombra leve derecha */
        0px 0px 0px rgba(0, 0, 0, 0.1),
        /* Sombra más notable abajo */
        0px 4px 12px rgba(0, 0, 0, 0.2);
        :nth-child(-n+3) {
          border: none !important;
        }
        :hover {
          border: none !important;
        }
    }
  }
  .countries_buttons {
    min-width: max-content !important;
    flex: 1 !important;
    background-color: white !important;
    border-color: white !important;
    color: #044389 !important;
    border-radius: 0px;
    @media screen and (max-width: 768px) {
      padding-left: 5% !important;
      text-align: left;
      display: flex;
    }
  }
  .countries_buttons:hover, .selected, .selected:focus {
    min-width: max-content !important;
    background-color: #f18805 !important;
    color: white !important;
    border-radius: 5px;
  }
  .custom_search_catalog > span > form {
    justify-content: center !important;
  }
  .radio_group_categories > div {
    margin-top: 2rem;
  }
  .radio_delivery_attempts > div {
    margin-top: 1rem;
  }
  .quantity_packages {
    text-align: -webkit-right;
  }
  .range_insurance_included::-webkit-slider-runnable-track {
    background-color: #044389; /* Color primario de Bootstrap */
  }
  .range_insurance_included::-webkit-slider-thumb {
    border: 2px solid #044389; /* Borde azul para contraste */
  }

  /* Para Firefox */
  .range_insurance_included::-moz-range-track {
    background-color: #044389; /* Color primario de Bootstrap */
  }
  .range_insurance_included::-moz-range-thumb {
    border: 2px solid #044389; /* Borde azul para contraste */
  }

  /* Para Internet Explorer y Edge */
  .range_insurance_included::-ms-track {
    background-color: #044389; /* Color primario de Bootstrap */
    border-color: transparent;
    color: transparent;
  }
  .range_insurance_included::-ms-thumb {
    border: 2px solid #044389; /* Borde azul para contraste */
  }
  .courier_img_card {
    align-content: center;
    min-height: 10rem;
    background-color: #F2F2F7ED;
    border-top-right-radius: 34px;
    border-top-left-radius: 34px;
  }
  .color_icon{ //color para el icono X de los tags
    stroke: white;
    width: 18px !important;
    height: 18px !important;
  }
  .courier_card {
  min-width: 200px;
  max-width: 300px;
  > div {
    padding: 0 !important;
    margin: 0 !important;
  }}
  .courier_div_card{
    background: #F9F9F9C7;
    border-bottom-left-radius: 34px;
    border-bottom-right-radius: 34px;
  }
  .courier_div_span_card {
    padding: 0.5rem;
    font-weight: 700;
    color: #000;
    text-align: left;
  }
  .icon_sevice_types {
    margin: 0.2rem;
  }
  .logo_img {
    max-width: 200px;
    max-height: 100px;
    cursor: pointer;
  }
  .skeleton-card {
    width: 30%;
  }
  .skeleton_container_card {
    justify-items: center !important;
    padding-bottom: 5%;
    .b-skeleton-img {
      border-radius: 12px !important;

    }
  }
  .text_insurance_included {
    text-align: left;
    padding-left: 2rem;
    size: 10px;
  }
  .col_courier_card {
    text-align: -webkit-center;
  }
  #slider-round {
      height: 10px;
  }
  #slider-round .noUi-connect {
      background: #044389;
  }
  #slider-round .noUi-handle {
    background: #044389;
    box-shadow: none;
    height: 18px;
    width: 18px;
    top: -5px;
    right: -9px; /* half the width */
    border-radius: 9px;
  }
  #slider-round .noUi-handle::before, #slider-round .noUi-handle::after {
    background: none !important;
  }
</style>
<style scoped>
  .container_couriers_catalog{
    max-width: none !important;
  }
  .custom_text {
    font-size: 20px;
    margin-top: 1rem;
  }
  .custom_div_msg {

    width: 100%;
    margin: 4rem;
  }
  .badge__cnt{
    margin-top: 8px;
    background: #044389;
    padding: 6px 16px;
    width: fit-content;
  }
  .comparator-button {
    font-size: 18px;
    font-weight: 300;
  }
  .comparator-couriers {
    width: fit-content;
  }
  .form-insurance {
    padding-left: 2rem;
    text-align: left !important;
  }
</style>
